import lodash from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Tag } from 'antd';
import Moment from 'react-moment';

const conversationWrapperStyles = {
    marginBottom: '10px',
};

const authorStyles = {
    fontWeight: 700,
    marginBottom: '5px',
};

const conversationBodyStyles = {
    margin: 0,
};

class LeadConversationTab extends Component {
    render() {
        const { conversations, isLoading } = this.props;
        return (
            <Fragment>
                {
                    !isLoading
                    && lodash.isEmpty(conversations)
                    && <p>Unfortunately, no data match these search criteria</p>
                }
                {!lodash.isEmpty(conversations)
                    && !lodash.isEmpty(conversations)
                    && conversations.map((conversation) => (
                        <div style={conversationWrapperStyles}>
                            <p style={authorStyles}>
                                {conversation.author}
                                {' '}
                                @
                                <Moment format="D MMM YYYY | HH:mm">
                                    {conversation.lastMessageDate}
                                </Moment>
                                {conversation.author === 'Chat Bot'
                                    && (
                                        <small>
                                            <Tag color="#28a745" className="tag">CHAT BOT</Tag>
                                        </small>
                                    )
                                }
                            </p>
                            <p style={conversationBodyStyles}>
                                {conversation.body}
                            </p>
                        </div>
                    ))}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({ ...state.Leads.Lead_profile.leadConversation });

export default connect(mapStateToProps)(LeadConversationTab);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_conversation_tab/Lead_conversation_tab.js